<template>
  <section
    class="content"  >
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
        >
          <router-link :to="{ name: 'TechnicianCreate' }">
            <button class="btn ">Add New</button>
          </router-link>
        </div>
        <v-server-table
          ref="tempuserTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import {mapState } from 'vuex';
import moment from 'moment';
export default {
  name: 'Technician',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      tempuserTable: null,
      columns: [
        'name',
        'mobileNumber',
        'regionName',
        'managerFirstname',
        'languageKnown',
        'status',
      ],

      options: {
        highlightMatches: true,
        sortable: [
          'name',
          'mobileNumber',
          'regionName',
          'managerFirstName',
          'languageKnown',
          'status',
        ],

        headings: {
          name: 'Name',
          mobileNumber: 'Contact',
          regionName: 'Geographical Area',
          languageKnown: 'Language',
          status: 'Status',
          managerFirstname: 'Journey Manager',
        },
        templates: {
          managerFirstname(row, query) {
            return `${query.managerFirstName} ${query.managerLastName}`;
          },

          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
        },

        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if(this.user.roleName == "GA Head"){
            params.regionRegionManager = this.user._id
          }
          if(this.user.roleName == "Journey Manager"){
            params.manager = this.user._id
          }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$tempuserDataRepository.list(params).catch(error => {
            console.error('technician.requestFunction-error:', error);
            this.$snotify.error('Get Technician', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.tempuserTable) {
        return this.tempuserTable.count > this.tempuserTable.limit ||
          this.tempuserTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
      
    }),
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'TechnicianDetails',
        params: {
          _id: data.row._id,
        },
        props: data.row,
      });
    },
    onLoaded() {
      this.tempuserTable = this.$refs.tempuserTable;
    },
  }
};
</script>

<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn{
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}
</style>



// WEBPACK FOOTER //
// Technician.vue?2fe64610